<template>
  <div class="hotel-home">
    <div class="con_nav">
      <nav-tab :nav-data="navData" />
    </div>
    <div class="con_center">
      <HomeTop />
      <!-- <HomeBottom /> -->
    </div>
    <div class="con_bottom">
      <layout-bottom />
    </div>
  </div>
</template>

<script>
import NavTab from '@/components/NavTab.vue'
import LayoutBottom from '@/components/LayoutBottom.vue'
import HomeTop from '@/components/home/homeTop.vue'
// import HomeBottom from '@/components/home/homeBottom'
export default {
  components: {
    NavTab,
    HomeTop,
    // HomeBottom,
    LayoutBottom
  },
  data() {
    return {
      navData: {
        index: 0,
        list: [
          {
            name: 'Hogar',
            link: '/'
          },
          {
            name: 'Sobre nosotros',
            link: '/sobre_nosotros'
          },
          {
            name: 'Preguntas frecuentes',
            link: '/preguntas_frecuentes'
          }
          // {
          //   name: 'HOW IT WORK',
          //   link: '#selector3'
          // }
          // {
          //   name: 'HOW IT WORKS',
          //   link: '/how_it_works'
          // },
          // {
          //   name: 'FAQ',
          //   link: '/faq'
          // },
          // {
          //   name: 'Loan Introduction',
          //   link: '/contact_us'
          // }
        ]
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.con_center{
  // background: url("~@/assets/images/loanImg/bn_ee.png") no-repeat top left;
  // margin-top: 70px;
  // background: linear-gradient(258deg, #43C5D6 0%, #4484EC 100%);
}
</style>
